/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var modelGet = require('common/util/modelGet');
var BreadcrumbView = require('common/views/BreadcrumbView');

var DepAuditFormView = require('./DepAuditFormView');
var SubmitEntityAudit = require('../services/SubmitEntityAudit');

var tmplDepAuditEditView = require('../templates/DepAuditEditView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepAuditEditView,

  className: 'dep-audit-edit-view container-fluid',

  ui: {
    auditForm: '.audit-form-container',
    breadcrumb: '.breadcrumb-container',
    submit: '.btn-submit'
  },

  regions: {
    auditForm: '@ui.auditForm',
    breadcrumb: '@ui.breadcrumb'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var audit = this.model.get('audit') || {};
    var auditId = this.model.get('auditId');
    var entityId = this.model.get('entityId');
    var entityName = modelGet(this.model, 'entityIdentifiers.entityName');

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#dep/dashboard',
            text: 'Home'
          },
          {
            link: '#dep/entity/' + entityId + '/dashboard',
            text: entityName
          },
          {
            text: audit.auditDate + ' - ' + audit.auditType,
            link: '#dep/entity/' + entityId + '/audit/' + auditId + '/dashboard'
          },
          {
            text: 'Edit Audit'
          }
        ]
      })
    );

    this.auditForm = new DepAuditFormView({
      model: this.model
    });

    this.showChildView('auditForm', this.auditForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        var formData = this.getFormData();
        SubmitEntityAudit(formData)
          .done(function() {
            Radio.channel('navigate').trigger('show:int:dp:entity:audit', formData.entityId, formData.auditId);
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.auditForm.parsley().whenValidate();
  },

  getFormData: function() {
    return this.auditForm.getFormData();
  }
});
